var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-collapsible-listbox',{ref:"dropdown",attrs:{"block":"","header-text":_vm.$options.HEALTH_STATUS_I18N_ASSIGN_HEALTH_STATUS,"toggle-text":_vm.dropdownText,"items":_vm.items},on:{"select":_vm.onSelect},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }